import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "referentials-categories" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Liste des catégories", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Catégories")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("sup", null, "ère", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("sup", null, "nde", -1)
const _hoisted_6 = { class: "ant-table ant-table-bordered categories-table" }
const _hoisted_7 = { class: "ant-table-container" }
const _hoisted_8 = { class: "ant-table-content" }
const _hoisted_9 = { style: {"table-layout":"auto"} }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", { class: "ant-table-thead" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Libellé"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_11 = ["id"]
const _hoisted_12 = { class: "ant-table-cell" }
const _hoisted_13 = { class: "ant-table-cell" }
const _hoisted_14 = { class: "actions" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Libellé")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_a_row, {
      type: "flex",
      class: "categories",
      justify: "center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_space, null, {
              default: _withCtx(() => [
                _hoisted_3,
                _createVNode(_component_a_select, {
                  value: _ctx.firstCategorieId,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstCategorieId) = $event)),
                  style: {"width":"300px"},
                  "dropdown-match-select-width": true,
                  onSelect: _ctx.onFirstCategorieSelectionChange
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: null }, {
                      default: _withCtx(() => [
                        _createTextVNode("1"),
                        _hoisted_4,
                        _createTextVNode(" catégorie")
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.firstCategories, (categorie) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: categorie.categorieId,
                        value: categorie.categorieId
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(categorie.reference) + ". " + _toDisplayString(categorie.libelle), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "onSelect"]),
                _createVNode(_component_a_select, {
                  value: _ctx.secondCategorieId,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.secondCategorieId) = $event)),
                  style: {"width":"300px"},
                  "dropdown-match-select-width": true,
                  disabled: _ctx.firstCategorieId == null
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: null }, {
                      default: _withCtx(() => [
                        _createTextVNode("2"),
                        _hoisted_5,
                        _createTextVNode(" catégorie")
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.secondCategories, (categorie) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: categorie.categorieId,
                        value: categorie.categorieId
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(categorie.reference) + ". " + _toDisplayString(categorie.libelle), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, { type: "flex" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          flex: "auto",
          align: "right"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: _ctx.createCategorie
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Créer une catégorie ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("table", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_draggable, {
              modelValue: _ctx.categories,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.categories) = $event)),
              dragging: false,
              tag: "tbody",
              "item-key": "categorieId",
              "ghost-class": "ghost",
              class: "ant-table-tbody",
              onChange: _ctx.updateReferences
            }, {
              item: _withCtx(({ element: categorie }) => [
                _createElementVNode("tr", {
                  id: categorie.categorieId,
                  class: "ant-table-row ant-table-row-level-0"
                }, [
                  _createElementVNode("td", _hoisted_12, _toDisplayString(categorie.reference) + ". " + _toDisplayString(categorie.libelle), 1),
                  _createElementVNode("td", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_a_button, {
                        onClick: ($event: any) => (_ctx.modifyCategorie(categorie))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Modifier ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      (_ctx.hasNotSubCategoriesOrEstimatifLines(categorie))
                        ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                            key: 0,
                            title: "Êtes-vous sûr de vouloir supprimer cette catégorie ?",
                            onConfirm: ($event: any) => (_ctx.deleteCategorie(categorie)),
                            "ok-text": "Supprimer",
                            "cancel-text": "Annuler"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_button, { danger: "" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Supprimer ")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["onConfirm"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 8, _hoisted_11)
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_a_modal, {
      warning: "",
      visible: _ctx.modalCreateOrUpdateCategorieIsVisible,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modalCreateOrUpdateCategorieIsVisible) = $event)),
      closable: true,
      "destroy-on-close": true,
      footer: null
    }, {
      title: _withCtx(() => [
        _createElementVNode("strong", null, _toDisplayString(_ctx.modalCreateOrUpdateCategorieTitle), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_alert, {
          message: "Liste des catégories pour lesquelles des marges sont manquantes.",
          type: "warning",
          style: {"margin-bottom":"10px"}
        }),
        (_ctx.createOrUpdateCategorie)
          ? (_openBlock(), _createBlock(_component_a_form, {
              key: 0,
              model: _ctx.createOrUpdateCategorie,
              "validate-messages": _ctx.validateMessages,
              autocomplete: "off",
              onFinish: _ctx.submitCreateOrUpdateCategorieHandler
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, {
                  name: ['libelle'],
                  rules: [{ required: true }],
                  "has-feedback": "",
                  "label-Col": {span: 6}
                }, {
                  label: _withCtx(() => [
                    _hoisted_15
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.createOrUpdateCategorie.libelle,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.createOrUpdateCategorie.libelle) = $event)),
                      placeholder: "Libellé de la catégorie"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      "html-type": "submit"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.createOrUpdateCategorie.categorieId > 0 ? "Mettre à jour" : "Créer"), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "validate-messages", "onFinish"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}